/* eslint-disable complexity */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useMemo, useContext, useEffect } from 'react';
import _ from 'lodash';
import { AppContext } from '@ctsu/loader';
import { Edit, ProtocolStatus, TextError } from 'components/FormikComponents';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { FormLayoutHeader } from 'components/FormHelpersPlain';
import {
  useCtxParseValue,
  GetFromCtxValue,
  getSysDate
} from 'helpers';
import { openConfirmation } from 'helpers/Confirmation';
import { bindActionCreators } from 'redux';
import { FasUndoAlt, FasSave, FasRedoAlt } from 'assets/icons';
import { useSelector, useDispatch } from 'react-redux';
import { bindLogger } from 'helpers/BindLogger';
import { DatePicker } from '@ctsu/datepicker';
import {
  cancelRequest,
  getProtocolDetails
} from 'actions/protocols/protocoldetail';
import { updateGroupStatusAction } from 'actions/protocols/admin';
import { httpStatusEnum } from 'appconstants';
import { openSnackbar } from 'helpers/Notifier';


const StatusChange = props => {
  const { multiPhase } = props;
  const [edit, setEdit] = useState(false);
  const [initValues, setInitValues] = useState(null);
  const context = useContext(AppContext);
  const {
    statusChangeInfo,
    grpProtStatus: grpStatus,
    setupIndicator,
    prtId,
    protocolNumber
  } = useSelector(data => data.prtDetails.prtInfo);
  const dispatch = useDispatch();
  const actions = useMemo(() => bindActionCreators({ cancelRequest, getProtocolDetails, updateGroupStatusAction }, dispatch), [dispatch]);


  const { protocolStsCanGoto } = useCtxParseValue('LOV_PROTOCOL_STATUS_GOTO');
  const ProtStatusToolTips = useCtxParseValue('PROTOCOL_STATUS_TOOLTIPS');
  const protRationaleToolTips = useCtxParseValue('PROTOCOL_RATIONALE_TOOLTIPS');
  const protReasonToolTips = useCtxParseValue('PROTOCOL_REASON_TOOLTIPS');
  protocolStsCanGoto.push({ from_state: 'FDAAA/IRB Completed', to_state: [] });
  const allowedNewStatus = _.filter(protocolStsCanGoto, {
    from_state: grpStatus
  });
  const lovStatusTooltips = useCtxParseValue('LOV_STATUS_TOOLTIPS');
  const { protocolStsRationale } = useCtxParseValue('LOV_PROTOCOL_STATUS_RATIONALE');
  const { protocolStsReason } = useCtxParseValue('LOV_PROTOCOL_STATUS_REASON');
  const { protocolStsRationaleReason } = useCtxParseValue(
    'LOV_PROTOCOL_STATUS_RATIONALE_REASON'
  );
  const ValidationMsg = useCtxParseValue('PROTOCOL_VALIDATION_MSG');
  function StatusValidation(valMsg) {
    const {
      dtlTemplateComplied,
      isIndIdeTypeComplied,
      isStudyDrugSetupComplied,
      cirbApprovalComplied,
      isVersionSetupComplied,
      latestIrbApprovalDate
    } = setupIndicator || {};


    let msg = '';
    msg += dtlTemplateComplied !== 'NA' && dtlTemplateComplied === 'N' ? `<li>${valMsg.DTLFlag}</li>` : '';
    msg += isIndIdeTypeComplied !== true ? `<li>${valMsg.IndIde}</li>` : '';
    msg += isStudyDrugSetupComplied !== true ? `<li>${valMsg.StudyAgents}</li>` : '';
    msg += cirbApprovalComplied === 'N' ? `<li>${valMsg.InitialIRB}</li>` : '';
    msg += (cirbApprovalComplied === 'NA' && latestIrbApprovalDate === null) ? `<li>${valMsg.InitialIRB}</li>` : '';
    msg += isVersionSetupComplied !== true ? `<li>${valMsg.Versions}</li>` : '';
    return msg ? `<ul class="redMark">${msg}</ul>` : '';
  }
  const preActiveMsg = StatusValidation(ValidationMsg);
  const canEdit = true;

  const refreshSummary = () => {
    if (protocolNumber) bindLogger(actions.getProtocolDetails, context)(protocolNumber);
  }

  const headerTitle = () => {
    return (
      <>
        Status Change Override
        <button
          className="fn-btn ml-1"
          type="button"
          onClick={refreshSummary}
        >
          <FasRedoAlt />
        </button>
      </>
    )
  };

  const getResonOptions = (values) => {
    let reasonOptions = [];
    if (!_.isEmpty(values)) {
      const { rationale, rqtGrpProtStatus } = values;
      const prtrationaleOptions = !_.isEmpty(rationale) ? _.filter(protocolStsRationaleReason,
        (o) => JSON.parse(o.rationale) === rationale) : [];
      const prtreasonOptions = !_.isEmpty(rqtGrpProtStatus) ? _.filter(protocolStsReason,
        (o) => JSON.parse(o.protocol_status) === rqtGrpProtStatus.value) : [];
      if (!_.isEmpty(prtrationaleOptions)) {
        reasonOptions = JSON.parse(prtrationaleOptions[0].reason);
      }
      if (!_.isEmpty(prtreasonOptions)) {
        reasonOptions = JSON.parse(prtreasonOptions[0].reason);
      }
      if (!_.isEmpty(reasonOptions) && reasonOptions.length >= 1 && reasonOptions[0]) {
        reasonOptions.unshift('');
        if (!_.isEmpty(rqtGrpProtStatus) && rqtGrpProtStatus.value === 'Temporarily Closed to Accrual' && !multiPhase) {
          _.remove(reasonOptions, c => c === "End of Initial Phase of Multi-phase protocol");
        }
      }
    }
    return reasonOptions;
  };

  const clearChanges = formProps => {
    formProps.resetForm({ ...formProps.initialValues });
  }

  const resetForm = formProps => {
    setEdit(!edit);
    clearChanges(formProps);
  };

  const getRationaleOptions = (status) => {
    let rationaleOptions = [];
    if (!_.isEmpty(status)) {

      const prtStsRationale = !_.isEmpty(status) ? _.filter(protocolStsRationale,
        (o) => JSON.parse(o.protocol_status) === status) : null;
      rationaleOptions = !_.isEmpty(prtStsRationale)
        ? JSON.parse(prtStsRationale[0].rationale)
        : [];
      if (rationaleOptions.length === 1 && rationaleOptions[0] === '0') {
        rationaleOptions = [];
      }
      if (rationaleOptions.length > 0 && rationaleOptions[0] !== '0') {
        rationaleOptions.unshift('');
      }
    }
    return rationaleOptions;
  }


  const allowedStatus = !_.isEmpty(allowedNewStatus) && allowedNewStatus[0].to_state;


  const validate = (values) => {
    const errors = {};

    if (_.isEmpty(values.rqtGrpProtStatus)) {
      errors.rqtGrpProtStatus = 'Status field is Required';
    }
 
    if (!values.rqtGrpProtStatusDate) {
      errors.rqtGrpProtStatusDate = 'Date field is Required';
    }

    if (!_.isEmpty(values.rqtGrpProtStatus) && !_.isEmpty(getRationaleOptions(values.rqtGrpProtStatus.value)) && _.isEmpty(values.rationale)) {
      errors.rationale = 'Rationale field is Required';
    }

    if (!_.isEmpty(values.rqtGrpProtStatus) && !_.isEmpty(getResonOptions(values)) && _.isEmpty(values.statusReason)) {
      errors.statusReason = 'Reason field is Required';
    }

    if (!_.isEmpty(values.statusReason) && values.statusReason === 'Other' && _.isEmpty(values.otherSpecify)) {
      errors.otherSpecify = 'Other Specify field is Required';
    }
    return errors;
  };

  const onSaveStatusChange = (values, formData) => {
    const data = {
      ...values,
      rqtGrpProtStatus: _.isEmpty(values.rqtGrpProtStatus) ? grpStatus : values.rqtGrpProtStatus.value
    }
    bindLogger(actions.updateGroupStatusAction, context)(data, prtId).subscribe(
      resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          openSnackbar({
            message: GetFromCtxValue(context, 'PROTOCOL_STATUS_CHANGE_SUCCESS'),
            variant: 'success',
            name: 'status_change'
          });
          setEdit(!edit);
          const valData = {
            rqtGrpProtStatus: null,
            rqtGrpProtStatusDate: null,
            rationale: null,
            statusReason: null,
            otherSpecify: ''
          };
          setInitValues({
            ...valData
          })
          formData.resetForm({
            ...valData
          });
        }
      },
      err => {
        setEdit(false);
      }
    );
  }

  const onSubmit = (values, formData) => {

    const confirmSave = () => {
      onSaveStatusChange({
        ...values
      }, formData);
    };
    const preActiveMsgData = values.rqtGrpProtStatus === 'Pre-Activation'
      && (setupIndicator && setupIndicator.dtlTemplateComplied === 'Y'
        && setupIndicator.dtlTemplateStatus === 'Approved') ? '<br /><span style="font-weight:700">Note:</span>&nbsp;Pre-Activating the protocol will automatically activate the DTL template currently in approved status for this protocol' : '';

    if (values.rqtGrpProtStatus === 'Active' && (grpStatus === 'Pre-Activation' || grpStatus === 'Approved')) {
      openConfirmation({
        title: 'Attestation',
        type: 'ATTEST',
        message: GetFromCtxValue(context, 'PROTOCOL_STATUS_ACTIVE_ATTESTATION'),
        onAction: confirmSave,
        name: 'attestation'
      });
    } else if (_.isEmpty(values.rqtGrpProtStatus)) {
      openConfirmation({
        message: 'Do you want to save the updated status date?',
        onAction: confirmSave,
        name: 'status_change'
      });
    } else {
      openConfirmation({
        message: GetFromCtxValue(context, 'PROTOCOL_STATUS_CHANGE_CONFIRM') + preActiveMsgData,
        onAction: confirmSave,
        name: 'status_change'
      });
    }
  };

  const getStatus = (statuses) => {
    let statusArr = null;
    if (statuses != null) {
      statusArr = _.map(statuses, 'from_state');
      statusArr = statusArr.filter((item) => {
        return !['In Review', 'Administratively Complete'].includes(item)
      });
      statusArr = statusArr.map((str) => {
        return {
          preActiveMsg,
          isDisabled: false,
          value: str,
          label: str,
          allowedStatus,
          secondary: lovStatusTooltips[str]
        }
      });
    }
    return statusArr;
  };
  const statusRecs = useMemo(() => getStatus(protocolStsCanGoto), [protocolStsCanGoto]);


  useEffect(() => {
    if (!_.isEmpty(statusChangeInfo)) {
      const valData = {
        rqtGrpProtStatus: null,
        rqtGrpProtStatusDate: null,
        rationale: null,
        statusReason: null,
        otherSpecify: ''
      };
      setInitValues({ ...valData });
    }
  }, [statusChangeInfo]);

  return (
    <>
      <div className={`form-layout-wrapper mb-3 ${canEdit ? 'editable' : ''} ${edit ? 'shadow-sm' : 'read-only'}`}>
        <Formik
          initialValues={initValues}
          enableReinitialize
          validate={validate}
          onSubmit={onSubmit}
        >
          {
            formik => {
              const { rqtGrpProtStatus, rqtGrpProtStatusDate, rationale, statusReason } = formik.values || {};
              return (
                <>
                  <FormLayoutHeader title={headerTitle()}>
                    <div className="d-flex row">
                      {canEdit && <Edit mode={edit} setMode={setEdit} formProps={formik} resetForm={resetForm} />}
                    </div>
                  </FormLayoutHeader>
                  <Form>
                    <div className="form-layout-body no-line">
                      <ul className="mb-1">
                        {edit ? (<ProtocolStatus
                          name="rqtGrpProtStatus"
                          isDisabled={!edit}
                          required
                          title={ProtStatusToolTips[rqtGrpProtStatus]}
                          value={rqtGrpProtStatus}
                          noOptionsMessage={() => null}
                          onChange={(op, e) => {
                            formik.setFieldValue("rqtGrpProtStatus", op);
                            if (_.isEmpty(getRationaleOptions(op.value))) {
                              formik.setFieldValue('statusReason', '');
                              formik.setFieldValue('rationale', '');
                              formik.setFieldValue('otherSpecify', '');
                            }
                          }}
                          classNamePrefix="protocol-status-select"
                          label="Group Protocol Status"
                          options={statusRecs}
                        />) : (
                          <li>
                            <label htmlFor="rqtGrpProtStatus">
                              <span className="form-layout-required">*</span>
                              Group Protocol Status
                            </label>
                            <div name="rqtGrpProtStatus" className="form-layout-input">{' '}</div>
                          </li>
                        )}
                        <li>
                          <label htmlFor="rqtGrpProtStatusDate">
                            <span className="form-layout-required">*</span>
                            Group Protocol Status Date
                          </label>
                          {edit ? (<div className="form-layout-input" title="">
                            <DatePicker
                              id="rqtGrpProtStatusDate"
                              name="rqtGrpProtStatusDate"
                              disabled={!edit}
                              required
                              uptoDuration={getSysDate()}
                              value={rqtGrpProtStatusDate}
                              pickDateTime
                              onChange={(e) => {
                                formik.setFieldValue('rqtGrpProtStatusDate', e);
                              }}
                            />
                            <ErrorMessage name="rqtGrpProtStatusDate" component={TextError} />
                          </div>) : <div className="form-layout-input">{' '}</div>}
                        </li>
                        <li>
                          <label htmlFor="rationale">
                            Rationale
                          </label>
                          {edit ? (<div className="form-layout-input" title="">
                            <Field
                              name="rationale"
                              id="rationale"
                              as='select'
                              value={rationale}
                              onChange={(op) => {
                                formik.setFieldValue('rationale', op.target.value);
                                formik.setFieldValue('statusReason', '');
                                formik.setFieldValue('otherSpecify', '');
                              }}
                              title={protRationaleToolTips[rqtGrpProtStatus]}
                              disabled={_.isEmpty(getRationaleOptions(rqtGrpProtStatus?.value))}
                              className="select-dropdown-indicator pl-1"
                            >
                              {
                                rqtGrpProtStatus && getRationaleOptions(rqtGrpProtStatus?.value).map(option => {
                                  return (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  )
                                })
                              }
                            </Field>
                            <ErrorMessage name="rationale" component={TextError} />
                          </div>) : <div className="form-layout-input">{' '}</div>}
                        </li>
                        <li>
                          <label htmlFor="statusReason">
                            Reason
                          </label>
                          {edit ? (<div className="form-layout-input" title="">
                            <Field
                              name="statusReason"
                              id="statusReason"
                              title={protReasonToolTips[rqtGrpProtStatus]}

                              onChange={(op) => {
                                formik.setFieldValue('statusReason', op.target.value);
                                formik.setFieldValue('otherSpecify', '');
                              }}
                              disabled={_.isEmpty(getResonOptions(formik.values))}
                              as='select'
                              className="select-dropdown-indicator pl-1"
                            >
                              {
                                rqtGrpProtStatus && getResonOptions(formik.values).map(option => {
                                  return (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  )
                                })
                              }
                            </Field>
                            <ErrorMessage name="statusReason" component={TextError} />
                          </div>) : <div className="form-layout-input">{' '}</div>}
                        </li>
                        <li>
                          <label htmlFor="otherSpecify">
                            Other Specify
                          </label>
                          {edit ? (<div className="form-layout-input" title="">
                            <Field
                              name="otherSpecify"
                              id="otherSpecify"
                              disabled={statusReason !== 'Other'}
                            />
                            <ErrorMessage name="otherSpecify" component={TextError} />
                          </div>) : <div className="form-layout-input">{' '}</div>}
                        </li>
                        <div className="form-layout-footer p-0">
                          <div className="form-layout-actions">
                            {
                              formik.dirty ? (
                                <><button
                                  className="mr-3 fn-btn color-dark-blue whiteSpace-nowrap"
                                  type="button"
                                  onClick={() => {
                                    clearChanges(formik);
                                  }}
                                >
                                  <FasUndoAlt />Clear Changes
                                </button>
                                  <button
                                    className="mr-3 btn turquoise"
                                    type="submit"
                                  >
                                    <FasSave />Save Changes
                                  </button>
                                </>
                              ) : null
                            }
                            <button
                              className="btn close"
                              type="button"
                              onClick={() => {
                                resetForm(props);
                              }}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </Form>
                </>
              )
            }
          }
        </Formik>
      </div>
    </>
  );
};

export default StatusChange;